var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEvinova = function SvgEvinova(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Evinova logotype",
    width: 266,
    height: 92,
    viewBox: "0 0 266 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2107 20.4414C34.5678 20.4414 29.9922 25.0161 29.9922 30.6588C29.9922 36.3026 34.5678 40.8773 40.2107 40.8773H72.2117C77.8555 40.8773 82.4297 36.3026 82.4297 30.6588C82.4297 25.016 77.8555 20.4414 72.2117 20.4414H40.2107Z",
    fill: "url(#paint0_linear_1330_64406)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6599 35.4297C25.0166 35.4297 20.4414 40.0038 20.4414 45.6476C20.4414 51.2904 25.0166 55.8655 30.6599 55.8655H62.6605C68.3038 55.8655 72.8788 51.2904 72.8788 45.6476C72.8788 40.0038 68.3038 35.4297 62.6605 35.4297H30.6599Z",
    fill: "url(#paint1_linear_1330_64406)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1758 35.4297C32.8891 38.6699 36.2928 40.8789 40.2131 40.8789H71.6991C69.9856 37.6386 66.5825 35.4297 62.6617 35.4297H31.1758Z",
    fill: "url(#paint2_linear_1330_64406)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7224 50.4141C38.0791 50.4141 33.5039 54.9887 33.5039 60.631C33.5039 66.2748 38.0791 70.8499 43.7224 70.8499H75.723C81.3658 70.8499 85.9419 66.2748 85.9419 60.631C85.9419 54.9887 81.3658 50.4141 75.723 50.4141H43.7224Z",
    fill: "url(#paint3_linear_1330_64406)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7209 50.4141C39.8 50.4141 36.3969 52.6229 34.6836 55.8633H62.6606C66.5814 55.8633 69.9845 53.6538 71.6979 50.4141H43.7209Z",
    fill: "url(#paint4_linear_1330_64406)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8361 43.4339H110.502C109.736 40.2767 107.029 38.1565 103.647 38.1565C100.309 38.1565 97.6477 40.232 96.8361 43.4339ZM91.3789 45.6443C91.3789 38.7882 96.6556 33.6016 103.647 33.6016C110.683 33.6016 115.96 38.7882 115.96 45.6892C115.96 46.1852 115.915 47.0421 115.825 47.5835H96.7908C97.5574 50.9212 100.264 53.1316 103.872 53.1316C106.533 53.1316 108.834 51.9586 110.006 50.1998H115.599C113.75 54.6651 109.24 57.6866 103.782 57.6866C96.6556 57.6866 91.3789 52.5 91.3789 45.6443Z",
    fill: "#3B0030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.492 34.1445H121.265L127.986 50.9681L131.414 42.6693C132.722 39.2863 133.218 36.535 132.722 34.1445H137.909C138.45 36.7608 137.909 39.9179 136.285 43.7516L130.557 57.1477H125.28L115.492 34.1445Z",
    fill: "#3B0030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.728 34.1445H140.676V57.1477H145.728V34.1445Z",
    fill: "#3B0030"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.748 57.1456V44.3361C165.748 40.8181 163.493 38.4725 160.019 38.4725C156.366 38.4725 153.931 40.863 153.931 44.4264V57.1456H148.879V34.1425H153.931V37.0747C155.78 34.8195 158.441 33.6016 161.688 33.6016C167.146 33.6016 170.799 37.2098 170.799 42.6671V57.1456H165.748Z",
    fill: "#3B0030"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.613 45.6443C192.613 41.5848 189.591 38.4725 185.532 38.4725C181.473 38.4725 178.405 41.5848 178.405 45.6443C178.405 49.7032 181.473 52.8155 185.532 52.8155C189.591 52.8155 192.613 49.7032 192.613 45.6443ZM173.219 45.6443C173.219 38.7887 178.495 33.6016 185.532 33.6016C192.523 33.6016 197.845 38.7887 197.845 45.6443C197.845 52.4999 192.523 57.6865 185.532 57.6865C178.495 57.6865 173.219 52.4999 173.219 45.6443Z",
    fill: "#3B0030"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.07 34.1445H202.844L209.564 50.9681L212.992 42.6693C214.3 39.2863 214.796 36.535 214.3 34.1445H219.487C220.028 36.7608 219.487 39.9179 217.863 43.7516L212.135 57.1477H206.858L197.07 34.1445Z",
    fill: "#3B0030"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240.129 45.6443C240.129 41.5848 237.107 38.4725 233.048 38.4725C228.943 38.4725 225.921 41.5848 225.921 45.6443C225.921 49.7032 228.943 52.8155 233.048 52.8155C237.107 52.8155 240.129 49.7032 240.129 45.6443ZM240.444 57.1456V53.4919C238.505 56.1081 235.573 57.6865 232.055 57.6865C225.56 57.6865 220.734 52.4999 220.734 45.6443C220.734 38.7887 225.56 33.6016 232.055 33.6016C235.438 33.6016 238.234 35.0448 240.129 37.4351V34.1425H245.181V57.1456H240.444Z",
    fill: "#3B0030"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1330_64406",
    x1: 29.9922,
    y1: 30.6593,
    x2: 82.4299,
    y2: 30.6593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB4A73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1330_64406",
    x1: 20.4414,
    y1: 45.6476,
    x2: 72.8787,
    y2: 45.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32EB9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F9EB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1330_64406",
    x1: 71.6989,
    y1: 38.1541,
    x2: 31.1759,
    y2: 38.1541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32EB9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1330_64406",
    x1: 33.504,
    y1: 60.6318,
    x2: 85.9418,
    y2: 60.6318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16D07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1330_64406",
    x1: 20.4415,
    y1: 53.1386,
    x2: 72.8788,
    y2: 53.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32EB9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEvinova);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "evinova.4f436756fb169df9e37cba00006326cf.svg";